import { render, staticRenderFns } from "./IndicadorStatusProduto.vue?vue&type=template&id=14e8c246&scoped=true"
import script from "./IndicadorStatusProduto.vue?vue&type=script&lang=js"
export * from "./IndicadorStatusProduto.vue?vue&type=script&lang=js"
import style0 from "./IndicadorStatusProduto.vue?vue&type=style&index=0&id=14e8c246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e8c246",
  null
  
)

export default component.exports